(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("plotly-js-material-design", [], factory);
	else if(typeof exports === 'object')
		exports["plotly-js-material-design"] = factory();
	else
		root["plotly-js-material-design"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition